var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPixhelpme(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46.83,
    height: 46.706,
    viewBox: "0 0 46.83 46.706",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3",
    transform: "translate(-10.5 -10.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8482",
    "data-name": "Caminho 8482",
    d: "M33.915,10.5A23.448,23.448,0,0,0,10.5,33.915c1.285,31.06,45.545,31.049,46.83,0A23.448,23.448,0,0,0,33.915,10.5Zm0,43.563A20.17,20.17,0,0,1,13.767,33.915c1.089-26.726,39.206-26.726,40.3,0A20.17,20.17,0,0,1,33.915,54.063Z",
    fill: "#38d2d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8483",
    "data-name": "Caminho 8483",
    d: "M32.659,18.7A8.07,8.07,0,0,0,24.6,26.759a1.634,1.634,0,0,0,3.267,0,4.792,4.792,0,1,1,4.792,4.792,1.634,1.634,0,0,0-1.634,1.634v4.629a1.634,1.634,0,0,0,3.267,0V34.655c9.366-2.113,8.048-15.748-1.634-15.955Z",
    transform: "translate(1.256 0.73)",
    fill: "#38d2d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8484",
    "data-name": "Caminho 8484",
    d: "M30.976,41.976a1.634,1.634,0,1,0,2.269.04A1.634,1.634,0,0,0,30.976,41.976Z",
    transform: "translate(1.785 2.764)",
    fill: "#38d2d9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPixhelpme);
export default __webpack_public_path__ + "static/media/pixhelpme.a6baf0f0de272deaf5f03b69dd65c0e4.svg";
export { ForwardRef as ReactComponent };